module.exports = __webpack_public_path__ + "static/media/bpbg-2022-5.86a57a01.gif";